import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clientService } from '../../services/clientService';
import { useToast } from '../../context/ToastContext';
import AdminHeader from '../../components/admin/AdminHeader';

const CreateClientPage: React.FC = () => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [submitting, setSubmitting] = useState(false);
    
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: ''
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!formData.email || !formData.phoneNumber || !formData.firstName || !formData.lastName) {
            showToast('Todos los campos son obligatorios', 'error');
            return;
        }

        try {
            setSubmitting(true);
            await clientService.createClientAdmin(formData);
            showToast('Cliente creado exitosamente. Se ha enviado un email con las credenciales.', 'success');
            navigate('/admin/clients');
        } catch (error: any) {
            console.error('Error creating client:', error);
            showToast(error.response?.data?.message || 'Error al crear el cliente', 'error');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <AdminHeader title="➕ Agregar Cliente Nuevo" backPath="/admin/clients" />
            
            <div className="container fade-in" style={{ maxWidth: '600px', margin: '0 auto' }}>
                <div className="card p-xl">
                    <p className="text-secondary mb-md">
                        Al crear un cliente desde aquí, se generará una contraseña automáticamente y se enviará por email. No hace falta que el cliente verifique su email.
                    </p>
                    
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-md">
                            <label className="form-label" htmlFor="firstName">Nombre</label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                className="form-input"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        
                        <div className="form-group mb-md">
                            <label className="form-label" htmlFor="lastName">Apellido</label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                className="form-input"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group mb-md">
                            <label className="form-label" htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                className="form-input"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group mb-lg">
                            <label className="form-label" htmlFor="phoneNumber">WhatsApp</label>
                            <input
                                type="tel"
                                id="phoneNumber"
                                name="phoneNumber"
                                className="form-input"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                required
                            />
                            <p className="text-xs text-secondary mt-xs">El número es obligatorio para notificaciones.</p>
                        </div>

                        <div className="flex gap-sm">
                            <button 
                                type="button" 
                                className="btn btn-outline" 
                                style={{ flex: 1 }}
                                onClick={() => navigate('/admin/clients')}
                            >
                                Cancelar
                            </button>
                            <button 
                                type="submit" 
                                className="btn btn-primary" 
                                style={{ flex: 1 }}
                                disabled={submitting}
                            >
                                {submitting ? 'Creando...' : 'Crear Cliente'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default CreateClientPage;
